import { useId } from 'react'
import { FieldShell } from './internal/FieldShell'
import { describedBy } from './internal/cx'

export type TextFieldProps = {
  label: string
  value: string
  onChange: (value: string) => void
  error?: string
  hint?: string
  required?: boolean
  type?: string
  placeholder?: string
  autoComplete?: string
  disabled?: boolean
  onBlur?: () => void
  id?: string
}

export function TextField({
  label,
  value,
  onChange,
  error,
  hint,
  required = false,
  type = 'text',
  placeholder,
  autoComplete,
  disabled = false,
  onBlur,
  id,
}: TextFieldProps) {
  const autoId = useId()
  const fieldId = id ?? autoId
  return (
    <FieldShell id={fieldId} label={label} required={required} error={error} hint={hint}>
      <input
        id={fieldId}
        className="ui-input"
        type={type}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        onBlur={onBlur}
        placeholder={placeholder}
        autoComplete={autoComplete}
        disabled={disabled}
        required={required}
        aria-invalid={error ? true : undefined}
        aria-describedby={describedBy(error && `${fieldId}-error`, !error && hint && `${fieldId}-hint`)}
      />
    </FieldShell>
  )
}
